import { createAsyncThunk } from "@reduxjs/toolkit";

import { type Dish } from "@fitness-app/data-models/entities/Dish";
import { type Database } from "@fitness-app/supabase";

import { type AsyncThunkCreator } from "../../../index";
import { NUTRITION_REDUCER_NAME } from "../types";

type Payload = {
  dish: Partial<Dish>;
  dishId: string;
};

type DishUpdate = Database["public"]["Tables"]["dish"]["Update"];

export const updateDish = createAsyncThunk<Dish | null, Payload, AsyncThunkCreator<string>>(
  `${NUTRITION_REDUCER_NAME}/updateDish`,
  async (payload, { rejectWithValue, extra: { db, analytics } }) => {
    const { error, data } = await db
      .from("dish")
      .update({ ...payload.dish, updatedAt: new Date().toISOString() } as unknown as DishUpdate)
      .eq("id", payload.dishId)
      .select()
      .single<Dish>();

    if (error) {
      return rejectWithValue(error.message);
    }

    analytics.track("update_dish");

    return data;
  },
);
